import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface AirMetric {
    value: string | number | null;
    isAlarm: boolean;
}

export interface AirQualityData {
    time: string;
    temperature: AirMetric;
    humidity: AirMetric;
    co2: AirMetric;
    pm25: AirMetric;
}

@Component({
    selector: 'app-air-quality',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './air-quality.component.html',
})
export class AirQualityComponent {
    data = input<AirQualityData>();
}
